import sanitizeHTML from 'sanitize-html';
import merge from 'lodash/merge';

export default {
	methods: {
		$sanitize(string) {
			return sanitizeHTML(string, {
				allowedTags: sanitizeHTML.defaults.allowedTags.concat([
					'img',
					'h1',
					'h2',
					'u',
					's',
					'span',
					'map',
					'area'
				]),
				allowedAttributes: merge(sanitizeHTML.defaults.allowedAttributes, {
					'*': ['style', 'class'],
					map: ['name'],
					area: [
						'alt',
						'coords',
						'href',
						'hreflang',
						'media',
						'rel',
						'shape',
						'target',
						'type'
					]
				})
			});
		}
	}
}
